export default "__VITE_ASSET__f996d75f__"